import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Switch } from "./ui/switch";

// Edit one of the accounts sharing the signed-in e-mail: name, password, active.
export default function AccountEditDialog({ account, onClose, onSaved }) {
  const [name, setName] = useState("");
  const [pw, setPw] = useState("");
  const [active, setActive] = useState(true);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (account) { setName(account.name || ""); setPw(""); setActive(account.active !== false); }
  }, [account]);
  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const body = { name };
      if (pw) body.password = pw;
      if (!account.is_current) body.active = active;
      await api.patch(`/auth/my-accounts/${account.user_id}`, body);
      toast.success("Konto gespeichert");
      onSaved();
      onClose();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    setSaving(false);
  };
  return (
    <Dialog open={!!account} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="account-edit-dialog">
        <DialogHeader>
          <DialogTitle>Konto bearbeiten</DialogTitle>
          <DialogDescription>{account?.email} · {account?.auth_provider === "google" ? "Google-Anmeldung" : "Passwort-Anmeldung"}</DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <div><Label>Name</Label><Input value={name} onChange={(e) => setName(e.target.value)} required className="mt-1.5" data-testid="account-edit-name" /></div>
          <div>
            <Label>{account?.has_password ? "Neues Passwort" : "Passwort festlegen"}</Label>
            <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} minLength={8} autoComplete="new-password"
              placeholder={account?.has_password ? "leer lassen = unverändert" : "mind. 8 Zeichen – dann auch Login per Passwort"} className="mt-1.5" data-testid="account-edit-password" />
          </div>
          {!account?.is_current && (
            <label className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 px-3 py-2.5">
              <span className="text-sm"><b>Aktiv</b><span className="block text-xs text-slate-500">Deaktiviert = Anmeldung mit diesem Konto gesperrt</span></span>
              <Switch checked={active} onCheckedChange={setActive} data-testid="account-edit-active" />
            </label>
          )}
          <DialogFooter>
            <Button type="submit" disabled={saving} data-testid="account-edit-save">{saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Speichern"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
